const osMap = {
  windows: 'Windows',
  mac: 'Mac',
  linux: 'Linux'
};

// usage: {{'windows' | os}}
export default function format(os) {
  if (os in osMap) return osMap[os];
  return os;
}
